const Adminroutes = {
  Dashboard: "/admin/dashboard",
  Courses: "/admin/courses",
  CourseTechnicality: "/admin/course-technicality",
  Programs: "/admin/programs",
  CreateProgram: "/admin/new-program",
  program_modules: "/admin/programs/modules",
  programSettings: "/admin/programs/:program_id/settings",
  AdminAnnouncements: "/admin/announcements",
  AdminNewAnnouncement: "/admin/new-announcement",
  EditAnnouncement: "/admin/announcement/:announce_id",
  EditAnnouncementLink: (announce_id: string) =>
    `/admin/announcement/${announce_id}`,
  programSettingsLink: (program_id: string) =>
    `/admin/programs/${program_id}/settings`,
  AdminTrainingCalendar: "/admin/training-calendar",
  ManagePostings: "/admin/postings",
  CourseDraft: "/admin/course-draft",
  AuditTrails: "/admin/audit-trail",
  Centers: "/admin/centers",
  DisciplineSpecialization: "/admin/discipline-specialization",
  Sessions: "/admin/session-terms",
  AdminResult: "/admin/results",
  DeferredAdmissions: "/admin/deffered-admissions",
  ACourse: "/admin/courses/:course_id",
  ACourseLink: (course_id: string) => `/admin/courses/${course_id}`,
  Trainees: "/admin/trainees",
  Trainer: "/admin/trainers",
  ProgramCluster: "/admin/program-cluster",
  ShortlistedApplicants: "/admin/shortlisted-applicants",
  Survey: "/admin/survey",
  CreateSurvey: "/admin/survey/create-new-survey",
  UserProfileHistory: "/admin/profile-history/:userid",
  UseTemplate: "/admin/survey/use-template/",
  UseTemplateLink: (tab_index: number) =>
    `/admin/survey/use-template/${tab_index}`,
  SurveyTemplate: "/admin/survey/survey-template/:tab_index",
  SurveyTemplateLink: (tab_index: number) =>
    `/admin/survey/survey-template/${tab_index}`,
  ViewSurvey: "/admin/survey/surveys",
  SingleSurvey: "/admin/survey/single-survey/:survey_uuid",
  CreateTemplate: "/admin/survey/survey-template/create-template",
  NewCourse: "/admin/courses/create-new-course",
  EditCourse: "/admin/courses/edit-course/:course_id",
  EditCourseLink: (course_id: string) =>
    `/admin/courses/edit-course/${course_id}`,
  Report: "/admin/reports",
  Calendar: "/admin/calendar",
  Setting: "/admin/settings",
  Roles: "/admin/roles",
  NewRole: "/admin/new-role",
  UserRoles: "/admin/roles/user",
  NewUser: "/admin/new-user",
  EditUser: "/admin/users/edit-user/:user_id",
  EditUserLink: (user_id: string) => `/admin/users/edit-user/${user_id}`,
  Alumni: "/admin/alumni",
  NewAlumni: "/admin/new-alumni",
  Badges: "/admin/badges",
  AssignedBadges: "/admin/assigned-badges",
  Review: "/admin/pending-review",
  ReviewTrainer: "/admin/pending-review/trainer/:trainer_id",
  ReviewTrainerLink: (trainer_id: string) =>
    `/admin/pending-review/trainer/${trainer_id}`,
  ReviewTrainee: "/admin/pending-review/trainee/:trainee_id",
  ReviewTraineeLink: (trainee_id: string) =>
    `/admin/pending-review/trainee/${trainee_id}`,
  ReviewApplication: "/admin/pending-review/application/:course_id",
  ReviewApplicationLink: (course_id: string) =>
    `/admin/pending-review/application/${course_id}`,
  ReviewTraineeCluster: "/admin/training-cluster/:course_id",
  ReviewTraineeClusterLink: (course_id: string) =>
    `/admin/training-cluster/${course_id}`,
  sponsor: {
    SponsorDashboard: "/admin/sponsors/dashboard",
    SponsorList: "/admin/sponsor/list",
    EachSponsor: "/admin/sponsor/:sponsor_id",
    EachSponsorLink: (sponsor_id: string) => `/admin/sponsor/${sponsor_id}`,

    UploadTrainees: "/admin/sponsor/:sponsor_id/upload/trainees",
    UploadTraineesLink: (sponsor_id: string) =>
      `/admin/sponsor/${sponsor_id}/upload/trainees`,
    sponsorBudget: "/admin/sponsor/:sponsor_id/budgets",
    sponsorBudgetLink: (sponsor_id: string) =>
      `/admin/sponsor/${sponsor_id}/budgets`,

    UploadedTrainees: "/admin/sponsor/uploaded/trainees",
    SponsorPayment: "/admin/sponsor/payment",
  },
};

export default Adminroutes;
